import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import locations from 'modules/locations/store/collections/locations'

interface Props {
  readonly?: boolean
  field: Field
}

const LocationGroupSelection = ({ readonly, field }: Props) => {
  const locationOptions = React.useRef(
    locations.map((location) => ({
      label: location.attributes.name,
      value: location.attributes.id,
    }))
  ).current

  return (
    <Select
      none={i18n.t('common.none')}
      readonly={readonly}
      field={field}
      options={locationOptions}
    />
  )
}

export default observer(LocationGroupSelection)
